module.exports = __webpack_public_path__ + "img/login-form-bg-180.png";